import styled from 'styled-components';
import { getColor, typeScale } from 'core/utils';

export const Wrapper = styled.div`
	color: ${getColor("salmon")};
	display: flex;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 16px;

	svg {
		margin-right: 5px;
	}
`;

export const Text = styled.p`
	margin: 0;
	font-weight: 600;
	line-height: 1.5;
`;
